import http from '../common/api';
import {ApiSettings} from "application";
import AppSettings from "application/globals/app-settings";

const signIn = async (email) => {
  const body = {
    'username': email,
    'app': AppSettings.reportKey
  };

  return await http.post(ApiSettings.signIn, body);
}

export default signIn;
